export default "__VITE_ASSET__BVzNvZaj__"